import React from 'react';
import { IconCalendarEvent, IconUsersGroup, IconDiscount2 } from '@tabler/icons-react';
const steps = [{
  step: 1,
  icon: <IconCalendarEvent size={22} stroke={1.8} style={{
    color: '#4A7AFF'
  }} data-id="element-12" />,
  title: 'I check-out si sincronizzano',
  description: 'CleanAI legge in tempo reale i calendari di Airbnb, Booking e degli altri OTA. Sa esattamente quando ogni appartamento si libera e incrocia gli orari con quelli degli host vicini a te.'
}, {
  step: 2,
  icon: <IconUsersGroup size={22} stroke={1.8} style={{
    color: '#4A7AFF'
  }} data-id="element-13" />,
  title: "L'algoritmo raggruppa per zona",
  description: "Appartamenti vicini con check-out ravvicinati vengono raggruppati automaticamente. L'algoritmo calcola il percorso più efficiente e assegna un unico professionista a più interventi in sequenza — zero ritardi, zero sovrapposizioni."
}, {
  step: 3,
  icon: <IconDiscount2 size={22} stroke={1.8} style={{
    color: '#4A7AFF'
  }} data-id="element-14" />,
  title: 'Costi divisi, qualità intatta',
  description: "Meno spostamenti = meno costi per tutti. Ogni host paga meno, il professionista guadagna di più grazie al volume, e la puntualità è garantita dall'ottimizzazione dei percorsi. Tutti vincono."
}];
export function CleaningSharingSection() {
  return <section className="w-full bg-page-bg py-20 md:py-24 px-5" data-id="element-15">
      <div className="max-w-6xl mx-auto" data-id="element-16">
        {/* Section badge */}
        <div className="flex justify-center mb-4" data-id="element-17">
          <span className="inline-block border rounded-full px-4 py-1 text-xs uppercase font-bold tracking-widest" style={{
          borderColor: '#FF4081',
          color: '#FF4081'
        }} data-id="element-18">
            PULIZIE IN SHARING
          </span>
        </div>

        {/* Heading */}
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-navy text-center" data-id="element-19">
          Le pulizie? Le condividi con chi è{' '}
          <span style={{
          color: '#FF4081'
        }} data-id="element-20">
            vicino a te.
          </span>
        </h2>

        {/* Pink underline accent */}
        <div className="flex justify-center mt-4" data-id="element-21">
          <div style={{
          width: '40px',
          height: '3px',
          background: '#FF4081',
          borderRadius: '2px'
        }} data-id="element-22" />
        </div>

        {/* Subtext */}
        <p className="font-body text-body-gray text-base md:text-lg mt-6 max-w-3xl mx-auto text-center leading-relaxed" data-id="element-23">
          CleanAI legge i check-out dai tuoi calendari, raggruppa gli
          appartamenti vicini con orari simili e assegna un unico professionista
          a più interventi in sequenza. Tu non fai nulla — il sistema fa tutto
          in automatico.
        </p>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mt-12" data-id="element-24">
          {steps.map(s => <div key={s.step} data-id="element-25">
              {/* Card */}
              <div className="bg-white rounded-none p-7 h-full border-2" style={{
            borderColor: '#FF4081'
          }} data-id="element-26">
                <div className="w-9 h-9 rounded-full flex items-center justify-center mb-4" style={{
              background: '#FF4081'
            }} data-id="element-27">
                  <span className="text-white font-bold text-sm" data-id="element-28">{s.step}</span>
                </div>
                <h3 className="font-heading font-semibold text-lg md:text-xl text-navy mb-3" data-id="element-29">
                  {s.title}
                </h3>
                <p className="font-body text-body-gray text-sm md:text-base leading-relaxed" data-id="element-30">
                  {s.description}
                </p>
              </div>
            </div>)}
        </div>

        {/* Shared callout below cards */}
        <div className="mt-10 max-w-3xl mx-auto rounded-lg py-5 px-8 text-center pt-[10px] pb-[10px]" data-id="element-31">
          <p className="font-body md:text-[15px] text-[16px]" style={{
          color: '#FF4081'
        }} data-id="element-32">
            Il cleaner è già in zona, il percorso è già ottimizzato. Tu non devi
            fare nulla.
          </p>
        </div>
      </div>
    </section>;
}